import { render, staticRenderFns } from "./CampusJobDetails.vue?vue&type=template&id=13b9c1be&scoped=true"
import script from "./CampusJobDetails.vue?vue&type=script&lang=js"
export * from "./CampusJobDetails.vue?vue&type=script&lang=js"
import style0 from "./CampusJobDetails.vue?vue&type=style&index=0&id=13b9c1be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b9c1be",
  null
  
)

export default component.exports